/* unplugin-vue-components disabled */import { render } from "./numberEditor.vue?vue&type=template&id=d28ac880"
import script from "./numberEditor.vue?vue&type=script&lang=js"
export * from "./numberEditor.vue?vue&type=script&lang=js"

import "./numberEditor.vue?vue&type=style&index=0&id=d28ac880&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__